import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleDotRegular from './chat-bubble-dot-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatBubbleDotRegular {...props} />;
}
SvgComponent.iconName = 'chatBubbleDotRegular';

export const ChatBubbleDotRegularIcon = svgIconWrapper(SvgComponent);
